import React from 'react';
import logo from '../img/darabase-logo.png';

export default class DarabaseLogo extends React.Component {

    constructor() {
        super();
    }

    render() {
        return (
            <>
                <img className='logo-darabase' src={logo} />
            </>
        )
    }
}
